import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Catalog } from "@/components/site/Catalog";
import { Bento } from "@/components/site/Bento";
import { RequestForm } from "@/components/site/RequestForm";
import { Faq } from "@/components/site/Faq";
import { Footer } from "@/components/site/Footer";
import { CartDrawer } from "@/components/site/CartDrawer";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Catalog />
      <Bento />
      <RequestForm />
      <Faq />
      <Footer />
      <CartDrawer />
    </main>
  );
}
